import { Link } from "react-router";
import type { Tag } from "~/models/tag";



interface Props {
    breadcrumbs: Tag[];
}

export default function BreadcrumbLinks({breadcrumbs}: Props){
    let cnt = 1;
    return (
        <>
            {breadcrumbs && (
                <p className="courseLinks">
                    {breadcrumbs.map(bc => (
                        <span key={bc.id}>
                            <Link to={`/courses/${bc.reference}`}>{bc.name}</Link>
                            <span>
                                {(cnt++) < breadcrumbs.length ? <span> &gt; </span> : <span></span>}
                            </span>
                        </span>
                    ))}
                </p>
            )}
        </>
    )
}